/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ReimbursementDeductions/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ReimbursementDeductions({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Insurances/Insurance/Subscription/EditAction/Content/Edit/Content/ReimbursementDeductions"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let insuranceValueData = fromData.useDataValue({ viewPath,
context: 'insurance',
})
let treatmentPlanValueData = fromData.useDataValue({ viewPath,
context: 'treatment_plan',
})
let aggregateData = fromHelpers.getValue(insuranceValueData, treatmentPlanValueData)
let dtColorsBlack = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.black'
        })
  return (<React.Fragment
>
<div
  data-testid="ReimbursementDeductions.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-Z1adSuS': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Remaining coverage"
 color={dtColorsNeutral600}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="insurance"
 data="treatment_plan"
 aggregate="helpers.js getValue"
 text={aggregateData}
 weight="medium"
 color={dtColorsBlack}
/>
</div>
{children}
</React.Fragment>)
}